import React, { useEffect, useState } from "react";
import { BsJournalArrowUp } from "react-icons/bs";
import { FcPackage } from "react-icons/fc";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import FarmerInventoryTable from "./Plants Inventory/farm_plants_inventory_table";
import { Formik, Form } from "formik";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import CustomInput from "../../CustomComponent/custom_input";
import { IventoryPlantInfo } from "../../SchemaInfo/info";
import { CreateFarmerInventoryScheama } from "../../Schemas/Farm support/farmer_inventory_schema";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { user } from "@heroui/react";

const FarmerInventory = () => {
  const [refresh, setRefresh] = useState(false);
  const [product, setProduct] = useState();
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    productId: "",
    userId: "",
    sortByDate: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [farmer, setFarmers] = useState();
  const [variants, setVariants] = useState([]);

  const store = useSelector((store) => store.login.user);
  console.log("store", store);
  let role = useSelector((store) => store?.login?.user);
  useEffect(() => {
    if (role && role.Role === process.env.REACT_APP_ROLE_CLIENT) {
      if (role.AdditionalRole !== "farmer partner") {
        navigate("/");
      }
    }
  }, [role]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/fa-inventorys/all-fa-inventorys", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.inventoryCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  useEffect(() => {
    performRequest("GET", "/pmg/product/all-products/")
      .then((res) => {
        if (res.status === 200) {
          setProduct(res?.data?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/pmg/cf-orders/all-fa-list/")
      .then((res) => {
        if (res.status === 200) {
          setFarmers(res?.data?.farmers);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = (values) => {
    let data = { ...values, userId: store?.UserId };
    setRefresh(true);
    performRequest("POST", "/pmg/fa-inventorys/create-fa-inventorys", data)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Inventory created successfully!");
          navigate("/farm-plants-inventory");
        } else {
          Toast("error", "Error while Creating");
        }
        setRefresh(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const getVariantsByProduct = (productId) => {
    performRequest("GET", `pmg/varient/get-var/${productId}`)
      .then((res) => {
        if (res.status === 200) {
          setVariants(res.data.data);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none m-0">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h2 className="page-title mb-1">
                  <FcPackage className="fs-2  me-1" /> Farmer Inventory
                </h2>
                <h4 className="text-muted m-0 p-0">Manage your inventory.</h4>
              </div>
              <div className="col-md-8 d-flex justify-content-end">
                <div className="btn-list text-end">
                  <div className="d-lg-block d-md-block d-none mt-3 mb-3">
                    <span data-bs-toggle="modal" data-bs-target="#modal-team">
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" /> Add New Items
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Products:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  productId: e.target.value,
                                })
                              }
                              value={filters.plantId}
                            >
                              <option value="">Select</option>
                              {product?.map((item) => (
                                <option value={item?.id}>{item?.title}</option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          {(store?.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S ||
                            store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select farmer:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    userId: e.target.value,
                                  })
                                }
                                value={filters.userId}
                              >
                                <option value="">Select</option>
                                {farmer?.map((item) => (
                                  <option value={item?.id}>
                                    {item?.userName}
                                  </option>
                                ))}
                              </DynamicFilterSelect>
                            </div>
                          )}

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Sort by Date:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByDate: e.target.value,
                                })
                              }
                              value={filters.sortByDate}
                            >
                              <option value="">Select</option>
                              <option value="asc">Ascending</option>
                              <option value="desc">descending</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      plantId: "",
                                      userId: "",
                                      sortByDate: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Products:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                productId: e.target.value,
                              })
                            }
                            value={filters.productId}
                          >
                            <option value="">Select</option>
                            {product?.map((item) => (
                              <option value={item?.id}>{item?.title}</option>
                            ))}
                          </DynamicFilterSelect>
                        </div>

                        {(store?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role ===
                            process.env.REACT_APP_ROLE_ADMIN_S) && (
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select farmer:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  userId: e.target.value,
                                })
                              }
                              value={filters.userId}
                            >
                              <option value="">Select</option>
                              {farmer?.map((item) => (
                                <option value={item?.id}>
                                  {item?.userName}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>
                        )}
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Sort by Date:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByDate: e.target.value,
                              })
                            }
                            value={filters.sortByDate}
                          >
                            <option value="">Select</option>
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    plantId: "",
                                    userId: "",
                                    sortByDate: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/viKbL9zD4Vw"}
                  id={"model-viedo"}
                  name={"farmer inventory"}
                ></CustomViedoCard>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <FarmerInventoryTable
                  refresh={refresh}
                  setRefresh={setRefresh}
                  data={data?.inventoryData}
                  currentPage={page}
                  itemsPerPage={50}
                />

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <span data-bs-toggle="modal" data-bs-target="#modal-team">
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" /> Add New Items
                      </button>
                    </span>
                  </div>
                </div>
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.inventoryData?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-team"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <Formik
          initialValues={IventoryPlantInfo}
          validationSchema={CreateFarmerInventoryScheama}
          onSubmit={handelSubmit}
          enableReinitialize
        >
          {(props) => (
            <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
              <div
                className="modal-dialog modal-dialog-centered w-100"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add a new inventory</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3 row">
                      <label className="form-label required">
                        Select Product
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="productId"
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            props.setFieldValue("productId", e.target.value);
                            getVariantsByProduct(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {product?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item?.title}
                            </option>
                          ))}
                        </CustomSelect>
                        {props.touched.productId && props.errors.productId && (
                          <p className="text-danger">
                            {props.errors.productId}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      {/* <label className="form-label required">Quantity</label>
                      <div className="w-100 col">
                        <CustomInput name="quantity" type="text" />
                        {props.touched.quantity && props.errors.quantity && (
                          <p className="text-danger">{props.errors.quantity}</p>
                        )}
                      </div> */}
                      {variants?.length > 0 && (
                        <div className="mb-3 mt-3">
                          

                          {variants.map((variant, index) => (
                            <div className="row mb-2" key={index}>
                              <div className="col-md-4">
                              <label className="form-label">Variants Title</label>
                                <input
                                  className="form-control"
                                  value={variant.title}
                                  disabled
                                />
                              </div>

                              <div className="col-md-4">
                              <label className="form-label">Quantity</label>
                                <CustomInput
                                  type="number"
                                  name={`variants[${index}].quantity`}
                                  placeholder="Enter Quantity"
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      `variants[${index}].variantId`,
                                      variant.id
                                    );

                                    props.setFieldValue(
                                      `variants[${index}].quantity`,
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>

                              <div className="col-md-4">
                              <label className="form-label">Unit</label>
                                <CustomSelect
                                  name={`variants[${index}].unit`}
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      `variants[${index}].variantId`,
                                      variant.id
                                    );

                                    props.setFieldValue(
                                      `variants[${index}].unit`,
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="">Select Unit</option>
                                  <option value="nos">Nos</option>
                                  <option value="kg">Kg</option>
                                </CustomSelect>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton
                          buttonText={"Add Item"}
                          data-bs-dismiss="modal"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="d-block d-lg-none d-md-none ms-2 me-2">
        <CustomViedoCard
          viedoLink={"https://www.youtube.com/embed/viKbL9zD4Vw"}
          id={"model-viedo2"}
          name={"farmer inventory"}
        ></CustomViedoCard>
      </div>
      <Footer />
    </div>
  );
};

export default FarmerInventory;
